"use client"

import type React from "react"

interface SMSFormProps {
  phone: string
  message: string
  onPhoneChange: (phone: string) => void
  onMessageChange: (message: string) => void
}

const SMSForm: React.FC<SMSFormProps> = ({ phone, message, onPhoneChange, onMessageChange }) => {
  return (
    <div className="form-group">
      <label htmlFor="sms-phone-input">Phone Number:</label>
      <input
        id="sms-phone-input"
        type="tel"
        value={phone}
        onChange={(e) => onPhoneChange(e.target.value)}
        placeholder="+1234567890"
        className="text-input"
      />

      <label htmlFor="sms-message-input">Message:</label>
      <textarea
        id="sms-message-input"
        value={message}
        onChange={(e) => onMessageChange(e.target.value)}
        placeholder="Your SMS message"
        className="text-input text-area"
        rows={3}
      />
    </div>
  )
}

export default SMSForm
